export default __webpack_public_path__ + "static/media/textCard1_base.23eeec4e.png";